RA.SearchHighlight = {
  init(stopWords, paramValue) {
	this.solutionContent = $('#solutionContent');
	this.solutionTitle = $('.solution-head__title');
    this.paramValue = paramValue;
	this.stopWords = stopWords;
	this.bindEvents();
	return this;
  },

  removeStopWords(stopWords) {
	var splitWords = this.paramValue.split(" ");
	var wordArray = [];
	$.each( splitWords, function( index, value ){
		value.replace(/\b[\w]+\b/g,
			function($0) {
			   var regex = new RegExp("\\b"+$0+"\\b","i");	
			   if (stopWords.search(regex) < 0) {
				 wordArray.push($0.trim());
			   }
			}
		); 
	});
	
	return wordArray;
  },

showHighlight() {
	  this.solutionContent.highlight(this.removeStopWords(this.stopWords));
	  this.solutionTitle.highlight(this.removeStopWords(this.stopWords));
  },
  
  removeHighlight() {
	  this.solutionContent.unhighlight();
	  this.solutionTitle.unhighlight();
  },
  bindEvents(){
	  var searchHighlight = this;
		$("#search-highlight-input").click(function(){
			let settingValue = $("#search-highlight-input").prop('checked');
			let data = {settingName: "SolutionSearchHighlight", settingValue: settingValue, action: "save", SToken: Config.csrf.value};
			let url = Config.contextPath + "/controller/userPreferences/";
			$.post(url, data).done(function(res) {
				if(res.status === "done") {
					if(settingValue === true){
						searchHighlight.showHighlight();
					}else{
						searchHighlight.removeHighlight();
					}
				} 
			});
		});
  }
};